import { useState } from 'react'
import { Button } from '~/design-system/primitives'
import { SocioSwiftModal } from './SocioSwiftModal'

export function BannerOptIn() {
  const [isOpenModal, setIsOpenModal] = useState(false)

  function handleOpenModal() {
    setIsOpenModal(true)
  }

  function handleCloseModal() {
    setIsOpenModal(false)
  }

  return (
    <>
      <SocioSwiftModal isOpen={isOpenModal} onClose={handleCloseModal} />
      <div
        className="flex flex-col items-center py-4 px-4 rounded bg-primary-socio"
      >
        <p className="text-white text-center text-sm p-1">
          Para <b> acumular cashback </b> e consultar seu saldo é necessário realizar o cadastro no <b> Programa Sócio Swift</b>.
        </p>

        <Button type="button" color="primary" className="w-full mt-4" onPress={() => handleOpenModal()}>Cadastrar</Button>
      </div>
    </>
  );
}
